export default __webpack_public_path__ + "static/media/nimLiSquare.a9faa954.webp";